<<template>  
  <prop-panel @close="close">
    <p slot="header">{{rs["fillCard"]}}</p>
    
    <div class="row" style="margin-left:0">
        <div class="input-group col-md-5" style="margin-left:0">
          <span class="input-group-addon" >{{rs["empId"]}}</span>
          <input ref="empId" type="number" class="form-control" @keyup.enter="onEnter" v-model="empId" >
        </div>
        <div class="input-group col-md-5" style="margin-left:0">
          <span class="input-group-addon" >{{rs["empName"]}}</span>
          <input type="text" class="form-control" readonly='true' v-model="empName" >
        </div>
    </div>
    <div class="row" style="margin-left:0">
        <div class="input-group col-md-5" style="margin-left:0">
          <span class="input-group-addon" >{{rs["deptName"]}}</span>
          <input type="text" class="form-control" readonly='true' v-model="deptName" >
        </div>
        <div class="input-group col-md-5" style="margin-left:0">
          <span class="input-group-addon" >{{rs["job"]}}</span>
          <input type="text" class="form-control"  readonly='true' v-model="job" >
        </div>
    </div>
    <div class="row" style="margin-left:0">
        <div class="input-group col-md-10" style="margin-left:0">
          <span class="input-group-addon" >{{rs["remark"]}}</span>
          <textarea  v-model="remark"
            rows="2" cols="30" type="text" class="form-control" />
        </div>
    </div>
    <div class="row" style="margin-left:0">
        <div class="input-group col-md-10" style="margin-left:0">
          <span class="input-group-addon" >{{rs["xdate"]}}</span>
          <select v-model="xdateType" v-bind:disabled='action=="View"' class="form-control">
            <option value='1' selected>{{rs["xdateT1"]}}</option> 
            <option value='2'>{{rs["xdateT2"]}}</option>
          </select>
        </div>
    </div>
    <div class="row" style="margin-left:0">
        <div class="input-group col-md-10" style="margin-left:0">
          <span class="input-group-addon" >{{rs["declareName"]}}</span>
          <div class="form-control">
            <label v-for='item in dinnerD' style="margin-left: 30px; float: left;">
            <input type="checkbox" :value="item.declareNo" v-model="dinner"/>{{item.declareName}}({{item.declareNo}})</label>
          </div>
        </div>
    </div>
    <div slot="footer">
      <button @click.stop="close" type="button" class="btn btn-default" data-dismiss="modal">{{rs["btn_close"]}}</button>
      <button @click.stop="rechaegex" type="button" class="btn btn-primary">{{rs["declare"]}}</button>
    </div>
  </prop-panel>
</template>

<<script>
export default {
  created: function() {
    this.fillDate=$.$DateNow(-1)
     /*if (!this.ws || (this.ws && this.ws.readyState != 1)){
        const wsImpl = window.WebSocket || window.MozWebSocket
        this.ws = new wsImpl('ws://localhost:9527/')
        this.ws.onmessage =  evt =>{
          if (evt.data == -1) this.msg = "两次指纹差别太大，请重新按压指纹！"
        }
        this.ws.onopen = ()=> {
          this.ftimes=3
          this.ws.send("getFingerprint")
        }
        this.ws.onclose = ()=>{
          console.log("close websocket")
          this.ws = null
        }
        this.ws.onerror = ()=>{
          this.$alert("电脑未授权，请联系管理员！")
        }
     }*/
  },
  props:["cfg", "rs", "url"],
  data(){
    return {
      empId: null,
      empName: null,
      deptName:null,
      job:null,
      duty:null,
      remark:null,
      rcNumber:0,
      emp: null,
      dinner:[],
      dinnerD:[],
      xdateType: 2
    }
  },
  methods:{
    close: function() {
      this.$emit("close");
    },
    rechaegex(){
      
      const sd = {}
      sd.empId=this.empId
      sd.empName = this.empName
      sd.dinner=this.dinner
      sd.remark = this.remark
      sd.xtype = this.xdateType
      this.$save(this.url + "AddX", sd, data=>{
        if (data.rs == 1){
          this.empId = null
          this.empName=null
          this.deptName=null
          this.job = null
          this.remark = null
          this.$refs.empId.select()
        }
        else if (data.rs==2) this.$alert("该员工已经订餐！")
      });
    },
    onEnter(){
      if (!this.empId || this.$trim(this.empId)=="") return
      this.$getData(this.url+"GetUser?No=" + this.empId + this.$urlSq(), data=>{
        if (data.rs==1){
          this.empName=data.emp.empName
          this.deptName=data.emp.deptName
          this.job = data.emp.job
          this.duty = data.emp.duty
          this.dinnerD = data.dinner
        }
        else if (data.rs==0){
          this.$alert(this.rs["notFound"])
          this.$refs.empId.select()
        }
      })
    }
  }
}
</script>
